export enum ChatSignals {
  SCROLL_TO_BOTTOM = "SCROLL_TO_BOTTOM",
}
